module.exports = __webpack_public_path__ + "img/icon_cangku@2x.862d5dc7.png";